import { render, staticRenderFns } from "./ModelJaego.vue?vue&type=template&id=158181f2&scoped=true"
import script from "./ModelJaego.vue?vue&type=script&lang=js"
export * from "./ModelJaego.vue?vue&type=script&lang=js"
import style0 from "./ModelJaego.vue?vue&type=style&index=0&id=158181f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158181f2",
  null
  
)

export default component.exports